module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "report"
  }, [_c('PageTitle', {
    attrs: {
      "pagetitle": "浏览网站",
      "tip": "掌握您网站访客还浏览了行业内哪些其他网站，离开您网站的访客去了行业内哪些其他网站，帮助您发现潜在竞争，及时调整营销策略"
    }
  }), _c('div', {
    staticClass: "time"
  }, [_c('TimeSpan', {
    attrs: {
      "filters": "7a"
    },
    on: {
      "change": _vm.onTimespanChange
    }
  }), _c('p', [_vm._v("分析网站："), _c('a', {
    staticClass: "blue-tip",
    attrs: {
      "href": _vm.currentDomain.domain,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.currentDomain.domainTitle))]), _vm._v("所在行业： "), _c('i', {
    staticClass: "blue-tip"
  }, [_vm._v(_vm._s(_vm.currentDomain.industry_1_name))]), _c('v-tooltip', {
    attrs: {
      "tip": '该行业分类为站点设置时选择的，如需修改请进入设置中心-站点管理中进行修改',
      "pos": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  })])], 1)], 1), _c('div', {
    staticClass: "zone"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-signal",
      "title": "趋势图"
    }
  }), _c('LineChart', {
    attrs: {
      "legend": _vm.legend,
      "xAxis": _vm.chartXAxis,
      "series": _vm.chartSeries
    }
  })], 1), _c('div', {
    staticClass: "zone"
  }, [_c('TableTitle', {
    attrs: {
      "icon": "fa fa-list",
      "title": _vm.tableTabTitle
    }
  }), _c('div', {
    staticClass: "nav-tabs"
  }, [_c('TabContent', {
    attrs: {
      "title": "主维度：",
      "tablist": _vm.tablist,
      "update": _vm.updateTab
    }
  }, [(_vm.total > 0) ? _c('DownloadBtn', {
    attrs: {
      "reportApi": _vm.reportApi,
      "params": _vm.query,
      "pagetitle": _vm.tableTabTitle,
      "subtitle": ""
    },
    slot: "extentTab"
  }) : _vm._e(), _c('div', {
    slot: "relatedomain"
  }, [_c('p', {
    staticClass: "tabAction"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-big",
    attrs: {
      "disabled": _vm.fetchLineChartabled
    },
    on: {
      "click": _vm.fetchLineChartData
    }
  }, [_vm._v("绘制选定行")])]), _c('p', [_vm._v("浏览了 "), _c('a', {
    staticClass: "blue-tip",
    attrs: {
      "href": _vm.currentDomain.domain,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.currentDomain.domainTitle))]), _vm._v("的访客还浏览了"), _c('i', {
    staticClass: "blue-tip"
  }, [_vm._v(_vm._s(_vm.currentDomain.industry_1_name) + " ")]), _vm._v("行业的以下网站，展示 TOP20 网站")])]), _c('div', {
    slot: "godomain"
  }, [_c('p', {
    staticClass: "tabAction"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-big",
    attrs: {
      "disabled": _vm.fetchLineChartabled
    },
    on: {
      "click": _vm.fetchLineChartData
    }
  }, [_vm._v("绘制选定行")])]), _c('p', [_vm._v("离开 "), _c('a', {
    staticClass: "blue-tip",
    attrs: {
      "href": _vm.currentDomain.domain,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.currentDomain.domainTitle))]), _vm._v("网站去向"), _c('i', {
    staticClass: "blue-tip"
  }, [_vm._v(_vm._s(_vm.currentDomain.industry_1_name) + " ")]), _vm._v("行业的以下网站，展示 TOP20 网站")])])], 1)], 1), _c('complex-table', {
    attrs: {
      "classname": 'data-table',
      "columns": _vm.columns,
      "list": _vm.tableDataList,
      "sum": {},
      "checkbox": _vm.hasCheckBox,
      "checkbox_length": _vm.checkboxLength
    }
  }, [_c('v-tooltip', {
    attrs: {
      "tip": '访客渗透=浏览了自己网站的访客还浏览A网站的访客数/浏览自己网站的访客数',
      "pos": "left"
    },
    slot: "uvrate"
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    staticStyle: {
      "margin-left": "5px"
    }
  })])], 1), (_vm.total > _vm.ps) ? _c('v-pagination', {
    attrs: {
      "total": _vm.total,
      "pn": _vm.pg,
      "ps": _vm.ps
    },
    on: {
      "updatepage": _vm.getTableData
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2837fcbc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2837fcbc!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/web/sites.vue
// module id = 731
// module chunks = 0